import React, { useEffect, useState } from "react";
import Styles from "./Styles.module.css";
import ToggleRadioButton from "../../../../Components/ToggleRadioButton/ToggleRadioButton";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import GradientButton from "../../../../Components/Button/GradientButton";
import upload from "../../../../Assets/images/upload_image.jpg";
import { Formik, useFormik } from "formik";
import ImagePreview from "../../../../Components/ImagePreview";
import { deliverySchema } from "../../../../App/Helpers/ValidationSchema/validator.js";
import DeliveryInfoApi from "../../../../App/api/deliveryinfo.api";
import { toast } from "react-toastify";

export default function Modal({ selectedItem, resetForm, setDeliveries, setIsModalOpen }) {
  // Initial form values

  const formInitialValue = {
    default_image: upload,
    name: "",
    description: "",
    store_can_create_category_of_sub_category: false,
    business: false,
  };
  const [initialVal, setInitialVal] = useState(formInitialValue);


  // handle delivery submit function
  const handleDeliverySubmit = async (values) => {
    console.log("values :", values);
    const payload = new FormData();
    console.log("payload :", payload);
    Object.keys(values).forEach((key) => payload.append(key, values[key]));

    try {
      const response = selectedItem
        ? await DeliveryInfoApi.updateIndividualDeliveryInfo(
            selectedItem?._id,
            payload
          )
        : await DeliveryInfoApi.addDelivery(payload);
      console.log("responses :", response);
      setDeliveries((prevDeliveries) => [...prevDeliveries, response?.data]);
      // toast notification
      toast.success(
        selectedItem
          ? "Delivery Information updated successfully!"
          : "Delivery Information Created Successfully!"
      );
      // fetchAllData();
      setIsModalOpen(true);
      resetForm(true);
    } catch (error) {
      console.error("Failed to save delivery:", error);
    }
  };

  const formik = useFormik({
    initialValues: initialVal,
    validationSchema: deliverySchema,
    enableReinitialize: true,
    onSubmit: handleDeliverySubmit,
   
  });

  

  useEffect(() => {
    if (selectedItem) {
      const newInitialVal = {
        default_image: selectedItem?.default_image || "",
        name: selectedItem?.name || "",
        description: selectedItem?.description || "",
        store_can_create_category_of_sub_category:
          selectedItem?.store_can_create_category_of_sub_category || false,
        business: selectedItem?.business || false,
      };
      setInitialVal(newInitialVal);
    }
    if (resetForm) {
      handleDiscard();
    }
  }, [selectedItem]);

  // Discard handler
  const handleDiscard = () => {
    formik.resetForm();
    setInitialVal(formInitialValue);
  };

  return (
    <div className={Styles.modalOverlay}>
      <div className={Styles.modalContent}>
        <div className={Styles.mapContainer}>
          <div className="d-flex justify-content-between gap-1">
            <div className="flex-1 flex-col">
              <div>
                <label htmlFor="default_image">
                  <input
                    type="file"
                    id="default_image"
                    accept=".jpeg, .jpg, .png, .gif, .tiff, .bmp, .webp"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      formik.setFieldValue("default_image", e.target.files[0])
                    }
                  />

                  {formik.values.default_image ? (
                    typeof formik.values.default_image === "object" ? (
                      <ImagePreview
                        file={formik.values.default_image}
                        id="default_image"
                      />
                    ) : (
                      <LazyLoadImage
                        src={
                          selectedItem?._id
                            ? formik.values.default_image
                            : upload
                        }
                        alt="img"
                        loading="lazy"
                        effect="blur"
                        style={{
                          width: "80%",
                          height: "90%",
                          objectFit: "contain",
                        }}
                        className="rounded-xl cursor-pointer"
                      />
                    )
                  ) : (
                    <LazyLoadImage
                      src={upload}
                      alt="img"
                      loading="lazy"
                      effect="blur"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                      className="rounded-xl cursor-pointer"
                    />
                  )}
                </label>
              </div>

              <div>
                <p className={Styles.inputLabel}>Description</p>
                <div className="flex flex-col">
                  <span className={Styles.formInput}>
                    <span className={Styles.inputSpan}>EN</span>
                    <textarea
                      className={Styles.inputField}
                      type="text"
                      name="description"
                      value={formik.values.description}
                      onChange={formik.handleChange}
                    />
                  </span>
                </div>
                {formik.touched.description && formik.errors.description ? (
                  <div className="text-red-600 font-bold">
                    {formik.errors.description}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="flex-1">
              <div className={Styles.inputWrapper}>
                <p className={Styles.inputLabel}>Business Type Name</p>
                <div className="flex flex-col">
                  <span className={Styles.formInput}>
                    <span className={Styles.inputSpan}>EN</span>
                    <input
                      className={Styles.inputField}
                      type="text"
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                    />
                  </span>
                </div>
                {formik.touched.name && formik.errors.name ? (
                  <div className="text-red-600 font-bold">
                    {formik.errors.name}
                  </div>
                ) : null}
              </div>

              {/* <p className={Styles.inputLabel}>Delivery Type</p>
              <div className={Styles.inputWrapper}>
                <select
                  className={Styles.dropdown_text}
                  name="delivery_type"
                  value={formik.values.delivery_type}
                  onChange={formik.handleChange}
                >
                  <option value="Store">Store</option>
                </select>
                {formik.touched.delivery_type && formik.errors.delivery_type ? (
                  <div className="text-red-600 font-bold">
                    {formik.errors.delivery_type}
                  </div>
                ) : null}
                <br />
              </div> */}

              {/* <p className={Styles.inputLabel}>Sequence Number</p>
              <div className="flex flex-col">
                <div className={Styles.formInput}>
                  <input
                    className={Styles.inputField}
                    type="text"
                    placeholder="Enter Your Sequence Number"
                    name="sequence_number"
                    value={formik.values.sequence_number}
                    onChange={formik.handleChange}
                  />
                </div>
              </div>
              {formik.touched.sequence_number &&
              formik.errors.sequence_number ? (
                <div className="text-red-600 font-bold">
                  {formik.errors.sequence_number}
                </div>
              ) : null} */}

              <div className="d-flex flex-column gap-5 my-1 text-base mt-5">
                {[
                  {
                    label: "Store can create category of sub category?",
                    name: "store_can_create_category_of_sub_category",
                    value:
                      formik.values.store_can_create_category_of_sub_category ||
                      false,
                  },
                  {
                    label: "Business",
                    name: "business",
                    value: formik.values.business || false,
                  },
                ].map((check) => (
                  <div className="d-flex gap-2" key={check.label}>
                    <ToggleRadioButton
                      Value={check.value}
                      handleChange={(value) =>
                        formik.setFieldValue(check.name, value)
                      }
                    />
                    <p>
                      {check.label} {check.value}
                    </p>
                  </div>
                ))}
              </div>

              <div className="flex flex-row gap-5 mt-5">
                <GradientButton
                  label="Discard"
                  type="button"
                  onClick={handleDiscard}
                />
                <GradientButton
                  label={selectedItem ? "Update" : "Submit"}
                  type="submit"
                  onClick={formik.handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
